import Vue from 'vue';
import Router from 'vue-router';
import Main2 from 'app/views/Main2.vue';
import Dashboard from 'app/components/dashboard/Dashboard.vue';
// const NotFound = () => import(/* webpackChunkName: "NotFound" */ './views/NotFound.vue');

Vue.use(Router);
const router = new Router({
  mode: 'history',
  base: '/',
  scrollBehavior() {
    return { x: 0, y: 0 };
  },
  routes: [
    {
      path: '/',
      component: Main2,
    },
    {
      path: '/dashboard',
      component: Dashboard,
    },
  ],
});
router.afterEach(to => {
  Vue.nextTick(() => {
    document.title = to.meta.title ? to.meta.title : 'Dropp.me';
  });
});

export default router;
